import { jwtDecode } from "jwt-decode";
import { useAuth } from "./useAuth";

export const useUpdateCurrentCar = () => {
  const { setAuth } = useAuth();

  const updateCurrentCar = (response) => {
    const decoded = jwtDecode(response.data.accessToken);
    const token = response.data.accessToken;

    localStorage.setItem("tk", token);

    setAuth({
      id: decoded.id,
      currentCar: decoded.currentCar,
      monitorBy: decoded.monitorBy,
      token: token,
      multipleCars: decoded.multipleCars,
      ndaAccepted: decoded.ndaAccepted,
      paymentWindow: decoded.paymentWindow,
      trialDays: decoded.trialDays,
      membershipAmount: decoded.membershipAmount,
      membership: decoded.membership,
    });
  };

  return updateCurrentCar;
};
